
const formname = "register"
const login = "כבר רשומים? התחברו"
const userLogin = "לחזרה למערכת המבדקים"

export { formname, login, userLogin }